module.exports = __webpack_public_path__ + "img/close-h.6fb5cde8.svg";